import React, { FunctionComponent, useEffect, useRef } from 'react';
import { Col, Row } from 'react-flexbox-grid';
import { ErrorMessage, ProductFormFieldChangeHandler } from '../../../../../types/interfaces';
import { getTextFactoryReturnType } from '../../../../../utils/TextUtils';
import { ProductFormCheckbox, ProductFormInput } from '../../../../../components/productFormFields';
import { replaceUnsupportedCharacters } from '../../../utils';

type ProfessionalFormGroupProps = {
  getText: getTextFactoryReturnType;
  formatErrorMessage: (error: ErrorMessage) => string;
  professionalInd?: boolean;
  change: ProductFormFieldChangeHandler;
};

const ProfessionalFormGroup: FunctionComponent<ProfessionalFormGroupProps> = (props: ProfessionalFormGroupProps) => {
  const { getText, formatErrorMessage, professionalInd, change } = props;
  const prevProfessionalIndRef = useRef<boolean | undefined>(professionalInd);

  // Clear securities firm name when checkbox is unchecked
  useEffect(() => {
    const prevValue = prevProfessionalIndRef.current;
    if (prevValue === true && professionalInd === false) {
      change('proInvolvement.professionalSecuritiesFirmName', null);
    }
    prevProfessionalIndRef.current = professionalInd;
  }, [professionalInd, change]);

  const handleSecurityFirmNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    change('proInvolvement.professionalSecuritiesFirmName', replaceUnsupportedCharacters(value));
  };

  return (
    <>
      <Col xs={12} md={professionalInd ? 4 : 12} lg={professionalInd ? 3 : 12} data-test="field_professionalInd">
        <ProductFormCheckbox
          className="checkbox-form"
          label={getText('individualCheckbox')}
          name="proInvolvement.professionalInd"
          formatErrorMessage={formatErrorMessage}
        />
      </Col>

      {professionalInd && (
        <Col sm={12} md={7} lg={8}>
          <Row className="mb-6 answer">
            <Col xs={12} md={12} data-test="field_professionalSecuritiesFirmName">
              <ProductFormInput
                handleOnChange={handleSecurityFirmNameChange}
                name="proInvolvement.professionalSecuritiesFirmName"
                label={getText('securitiesFirmName')}
                maxLength={254}
                className="mb-3"
                formatErrorMessage={formatErrorMessage}
              />
            </Col>
          </Row>
        </Col>
      )}
    </>
  );
};

export default ProfessionalFormGroup;
